import React, { useEffect, useState } from 'react';
import { Toggle, Typography } from '@statsbomb/kitbag-components';
import { SCOUT_BIOMETRIC_FILTERS } from '../../ScoutResults.constants';
import { mf_Leagues } from '../../../../../apollo';
import { trackObjectChangeEvent } from '../../../../../utils/helpers/snowplow';
import { useStore } from '../../../../../store/useStore';
import { ScoutToggleWrapper } from '../BiometricFilters.styles';

const TransferPortalToggle = () => {
  const selectedBiometrics = useStore((s) => s.selectedBiometrics);
  const setSelectedBiometrics = useStore((s) => s.setSelectedBiometrics);
  const currentLeague = mf_Leagues();
  const portalFilter = selectedBiometrics.find(
    (b) => b.key === SCOUT_BIOMETRIC_FILTERS.ncaaTransferPortal.key
  );
  const [isTransferPortal, setIsTransferPortal] = useState(portalFilter?.value);

  useEffect(() => {
    setIsTransferPortal(portalFilter?.value);
  }, [selectedBiometrics]);

  const setPortal = (checked) => {
    setIsTransferPortal(!checked);
    const otherBiometrics = selectedBiometrics.filter(
      (b) => b.key !== SCOUT_BIOMETRIC_FILTERS.ncaaTransferPortal.key
    );
    const newPortalFilter = {
      key: SCOUT_BIOMETRIC_FILTERS.ncaaTransferPortal.key,
      value: !checked,
    };
    trackObjectChangeEvent(
      'Widget',
      'Edit',
      SCOUT_BIOMETRIC_FILTERS.ncaaTransferPortal.key
    );
    setSelectedBiometrics(otherBiometrics.concat(newPortalFilter));
  };

  // If the current league is not NFL (1409) don't show the toggle
  return currentLeague !== 1409 ? (
    <ScoutToggleWrapper>
      <Typography variant="headingSmall">Transfer Portal</Typography>

      <Toggle
        id="transfer-portal-toggle"
        label="Show transfer portal players only"
        onChange={() => setPortal(isTransferPortal)}
        checked={isTransferPortal}
        size="small"
        testId="transfer-portal-toggle"
      />
    </ScoutToggleWrapper>
  ) : null;
};

export default TransferPortalToggle;
